<template>
  <div class="row camunda-admin" v-if="canRead">
    <div class="space-below-collapse col-md-12">
      <button type="button" class="btn btn-fill btn-info btn-wd pull-right" v-if="canEdit" @click="deleteDeployments">Delete All Department Deployments</button>
      <button type="button" class="btn btn-fill btn-info btn-wd pull-right" v-if="canEdit" @click="createDeployments">New Deployment(s)</button>
      <tabs @activated="loadDeploymentsForDepartment">
        <tab-pane v-for="department in departments" :title="department.name" :key="department.id">
          <div v-if="loading" style="text-align: center; margin-top: 150px;">
            <img src="static/img/loading.gif" />
          </div>
          <department-deployments v-else :data="department"></department-deployments>
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import PButton from 'src/components/UIComponents/Button.vue'
  import DepartmentDeployments from 'src/components/Dashboard/Views/Camunda/DepartmentDeployments'
  import Permissions from 'src/utilities/permissions'
  import {Tabs, TabPane} from 'src/components/UIComponents'
  import {objectByName} from 'src/utilities/utils'
  import {OK} from 'http-status-codes'

  export default {
    components: {
      DepartmentDeployments,
      PButton,
      Tabs,
      TabPane
    },
    computed: {
      ...mapGetters({
        departments: 'departments/results',
      }),
      canRead() {
        return this.$can('read', Permissions.CAMUNDA)
      },
      canEdit() {
        return this.$can('edit', Permissions.CAMUNDA)
      }
    },
    data() {
      return {
        activeDepartment: null,
        loading: true
      }
    },
    methods: {
      createDeployments() {
        this.$eventHub.$emit('show-modal-1', 'Create Deployments', this.activeDepartment, '400px')
      },
      deleteDeployments() {
        this.$eventHub.$emit('show-modal-1', 'Delete Deployments', this.activeDepartment, '400px')
      },
      async loadDeploymentsForDepartment(departmentName) {
        this.loading = true
        const department = objectByName(this.departments, departmentName)
        this.activeDepartment = department

        const response = await this.$store.dispatch('camunda/fetchPtracCamundaDeploymentsByDepartmentAdmin', department.id)

        if (OK === response.status) {
          this.loading = false
        }
      },
      async init() {
        this.$store.commit('camunda/resetDeploymentsForDepartment', this.activeDepartment.id)
        await this.loadDeploymentsForDepartment(this.activeDepartment.name)
      }
    },
    async mounted() {
      await this.$store.cache.dispatch('departments/fetchAll')
      this.$eventHub.$on('refreshCamundaDeployments', this.init)
      this.$eventHub.$on('camundaDeploymentArchived', this.init)
      this.$eventHub.$on('camundaDeploymentDeleted', this.init)

      this.activeDepartment = this.departments[0]
      await this.init()
    },
    beforeDestroy() {
      this.$eventHub.$off('refreshCamundaDeployments')
      this.$eventHub.$off('camundaDeploymentArchived')
    }
  }
</script>
<style>
  .space-below-collapse {
    margin-bottom: 15px;
  }
</style>
